import {IMerchantCategoryLabel} from 'app/common/interfaces/IReport';

export const LOGOUT = 'Log Out';
export const GoogleShoppingId = '6096d6e97ccfc76cdc71d671';

export const ColorScheme = {
  domain: ['#7A4AFF', '#3A56FC', '#AB4AFF', '#33CFFF', '#00F98E', '#DE4AFF', '#4588F4', '#46F7EE', '#00F98E', '#FF4ABD']
};

export const GreenColorScheme = {
  domain: ['#FF2468', '#1EC1AA', '#5F6DF0', '#C8CAD6']
};

export const GoogleShoppingVisibilityColorScheme = {
  domain: ['#FF2468', '#1EC1AA', '#5F6DF0', '#00F98E']
};

export const PricingGapChartColorScheme = {
  domain: ['#7FDF9A', '#FF7070', '#3430F4'],
};

export const ReportMerchantCategoryLabels: IMerchantCategoryLabel[] = [
  {
    title: 'Custom Label 0',
    googleMerchantKey: 'customLabel0',
    customFieldsKey: 'custom_label_0',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 1',
    googleMerchantKey: 'customLabel1',
    customFieldsKey: 'custom_label_1',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 2',
    googleMerchantKey: 'customLabel2',
    customFieldsKey: 'custom_label_2',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 3',
    googleMerchantKey: 'customLabel3',
    customFieldsKey: 'custom_label_3',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
  {
    title: 'Custom Label 4',
    googleMerchantKey: 'customLabel4',
    customFieldsKey: 'custom_label_4',
    labels: [
      { columnLabel: 'Competitiveness', columnValue: 'competitiveness' },
      { columnLabel: 'Price Gaps', columnValue: 'priceGaps' },
    ],
  },
];

